import { c as _c } from "react/compiler-runtime";
// `<ProbabilityBar>` — multi-segment horizontal bar. Each segment is one
// outcome of a market, sized proportional to its probability. Used in
// market OG cards.

import { OG_TOKENS } from '../tokens';
export interface ProbabilitySegment {
  /** Outcome label ("Yes", team name, etc.). */
  label: string;
  /** Probability in `[0, 1]`. */
  probability: number;
  /** Hex color for the segment. */
  color: string;
}
export interface ProbabilityBarProps {
  segments: readonly ProbabilitySegment[];
  width: number;
  height: number;
  /** Show the probability `%` inside each segment. Default `true`. */
  showLabels?: boolean;
}
export function ProbabilityBar(props) {
  const $ = _c(16);
  const showLabels = props.showLabels ?? true;
  const total = props.segments.reduce(_temp, 0);
  if (total <= 0) {
    let t0;
    if ($[0] !== props.height || $[1] !== props.width) {
      t0 = <div style={{
        display: "flex",
        width: props.width,
        height: props.height,
        background: OG_TOKENS.gray800,
        borderRadius: 8
      }} />;
      $[0] = props.height;
      $[1] = props.width;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] !== props.height || $[4] !== props.width) {
    t0 = {
      display: "flex",
      width: props.width,
      height: props.height,
      borderRadius: 8,
      overflow: "hidden"
    };
    $[3] = props.height;
    $[4] = props.width;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== props.segments || $[7] !== showLabels || $[8] !== total) {
    let t2;
    if ($[10] !== showLabels || $[11] !== total) {
      t2 = (seg, i) => {
        const pct = seg.probability / total * 100;
        return <div key={`${seg.label}-${String(i)}`} style={{
          display: "flex",
          width: `${pct.toFixed(1)}%`,
          height: "100%",
          background: seg.color,
          alignItems: "center",
          justifyContent: "center",
          color: "#ffffff",
          fontSize: 24,
          fontWeight: 700
        }}>{showLabels && pct >= 8 ? `${Math.round(pct)}%` : ""}</div>;
      };
      $[10] = showLabels;
      $[11] = total;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    t1 = props.segments.map(t2);
    $[6] = props.segments;
    $[7] = showLabels;
    $[8] = total;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[13] !== t0 || $[14] !== t1) {
    t2 = <div style={t0}>{t1}</div>;
    $[13] = t0;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}
function _temp(s, x) {
  return s + x.probability;
}